// Local translations
export const T = {
  en_GB: {
    qrCode: "QR Code",
    downloadPng: "Download PNG",
    close: "Close",
    description: "Scan this QR code or download it as a PNG image.",
  },
  nb_NO: {
    qrCode: "QR-kode",
    downloadPng: "Last ned PNG",
    close: "Lukk",
    description: "Skann QR-koden eller last den ned som et PNG-bilde.",
  },
} as const;
